import { ButtonIconTransparent } from '@fukku/button/Icon/Transparent'
import fukkuStyles from '@fukku/styles/srOnly.module.css'
import { IconCloseBig } from 'icons/components/IconCloseBig'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'
import { useDialogContext } from '../../hooks/useDialogContext'

import styles from '../Header.module.scss'

type CloseButtonProps = {
	readonly onClose?: () => void
	readonly hasDraggableControl?: boolean
}

export function CloseButton({
	onClose,
	hasDraggableControl,
}: CloseButtonProps) {
	const { t } = useLabels()
	const { api, preventClose } = useDialogContext()

	return (
		(!preventClose || onClose) && (
			<div
				className={cx(hasDraggableControl ? fukkuStyles.srOnly : styles.close)}
			>
				<ButtonIconTransparent
					className={styles.area}
					onClick={onClose ?? api.close}
				>
					<IconCloseBig
						width={20}
						height={20}
						alt={t('accessibility.icon.cross.close.text')}
					/>
				</ButtonIconTransparent>
			</div>
		)
	)
}
